/**
 * The interactive shell is `.cb-hp`. Mount hosts differ per SPA entry (`#app`, `#portal`, `#paynow`, …).
 * Vue 3 may leave an outer mount wrapper; animation code must find the inner `.cb-hp` so
 * `cb-hp--hidden` is cleared on the visible root.
 *
 * Important: Portal uses `#portal` only — querying only `#app` returns null → animations and
 * App.vue `clearStuckHidden` never run → UI stays invisible under `cb-hp--hidden`.
 * Same for `#view_voucher` (Boleto voucher page).
 */
const MOUNT_ROOT_IDS = ['app', 'portal', 'paynow', 'claim_gift', 'connector', 'view_voucher']

export function getCheckoutAppShell () {
  if (typeof document === 'undefined') return null
  let root = null
  for (let i = 0; i < MOUNT_ROOT_IDS.length; i++) {
    root = document.getElementById(MOUNT_ROOT_IDS[i])
    if (root) break
  }
  if (!root) return null
  if (root.classList?.contains('cb-hp')) return root
  const inner = root.querySelector('.cb-hp')
  return inner || null
}

/** Modal height for dropdown positioning / layout — same pattern as shell focus (portal has no `#app`). */
export function getHostedShellHeight () {
  const shell = getCheckoutAppShell()
  if (shell) return shell.offsetHeight
  if (typeof document !== 'undefined' && document.documentElement) {
    return document.documentElement.clientHeight || 0
  }
  return 0
}
